import { Skeleton } from "@/components/ui/skeleton";

const MetricDetailRowSkeleton = () => (
  <div className="flex items-center gap-4 rounded-md border border-border/60 bg-card/95 p-3">
    <div className="flex flex-1 items-center gap-3">
      <Skeleton className="h-9 w-9 rounded-md" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-3 w-56" />
      </div>
    </div>
    <Skeleton className="hidden h-6 w-64 md:block" />
    <div className="space-y-1.5">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-24" />
    </div>
  </div>
);

export default MetricDetailRowSkeleton;
